<script lang="ts"> // YearSlider.svelte
let {
    minDate = -4260212250000, // 01-01-1835
    maxDate = 1924904580000, // 31-12-2030
    minValue = $bindable(minDate), // Load at minDate
    maxValue = $bindable(maxDate), // Load at maxDate
    onchange = () => {
    }
}: {
    minDate?: number;
    maxDate?: number;
    minValue?: number;
    maxValue?: number;
    onchange?: (min: number, max: number) => void;
} = $props();

let fromThumbX = $state(0);
let toThumbX = $state(100);

$effect(() => {
    fromThumbX = (minValue - minDate) / (maxDate - minDate) * 100;
    toThumbX = (maxValue - minDate) / (maxDate - minDate) * 100;
})

function pointerdown(event: PointerEvent) {
    const thumb = event.currentTarget as HTMLElement;
    const rail = thumb.parentElement?.querySelector('.rail') as HTMLElement;

    const onPointerMove = (moveEvent: PointerEvent) => {
        const railRect = rail.getBoundingClientRect();
        let newX = ((moveEvent.clientX - railRect.left) / railRect.width) * 100;

        if (thumb.classList.contains('thumb-from')) {
            fromThumbX = Math.min(Math.max(newX, 0), toThumbX);
            minValue = Math.round(minDate + (fromThumbX / 100) * (maxDate - minDate));
        } else {
            toThumbX = Math.max(Math.min(newX, 100), fromThumbX);
            maxValue = Math.round(minDate + (toThumbX / 100) * (maxDate - minDate));
        }
    };

    const onPointerUp = () => {
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        triggerChange();
    };

    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
}

function triggerChange() {
    onchange(minValue, maxValue);
}

function timestampToDatetime(time: number): string {
    const date = new Date(time);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

let formattedMinValue = $state(timestampToDatetime(minValue));
let formattedMaxValue = $state(timestampToDatetime(maxValue));

$effect(() => {
    formattedMinValue = timestampToDatetime(minValue);
});

$effect(() => {
    formattedMaxValue = timestampToDatetime(maxValue);
});

function updateMinValueFromInput(value: string) {
    minValue = new Date(value).getTime();
    triggerChange();
}

function updateMaxValueFromInput(value: string) {
    maxValue = new Date(value).getTime();
    triggerChange();
}
</script>

<div class="double-range-slider">
    <div class="slider">
        <div class="rail"></div>
        <div class="active-rail" style:left="{fromThumbX > 0 ? fromThumbX: 0}%"
             style:right="{100 - (toThumbX < 100 ? toThumbX : 100)}%"></div>
        <div class="thumb thumb-from" onpointerdown={pointerdown} style:left="{fromThumbX > 0 ? fromThumbX: 0}%"></div>
        <div class="thumb thumb-to" onpointerdown={pointerdown} style:left="{toThumbX < 100 ? toThumbX : 100}%"></div>
    </div>
    <div class="values">
        <input type="date" bind:value={formattedMinValue} min={timestampToDatetime(minDate)} max={timestampToDatetime(maxDate)}
               onblur={() => updateMinValueFromInput(formattedMinValue)}/>
        <input type="date" bind:value={formattedMaxValue} min={timestampToDatetime(minDate)} max={timestampToDatetime(maxDate)}
               onblur={() => updateMaxValueFromInput(formattedMaxValue)}/>
    </div>
</div>


<style lang="scss">
  .double-range-slider {
    display: flex;
    flex-direction: column;
    gap: 10px;
    touch-action: none;

    .slider {
      width: 100%;
      position: relative;

      .rail {
        height: 4px;
        background: #ccc;
      }

      .thumb {
        position: absolute;
        top: 50%;
        width: 20px;
        height: 20px;
        background: #1F4588;
        border-radius: 50%;
        cursor: pointer;
        transition: background-color 0.2s;
        transform: translateY(-50%) translateX(-50%);

        &:hover {
          background-color: #1F4588;
        }
      }

      .active-rail {
        position: absolute;
        top: 0;
        height: 4px;
        background: #1F4588;
        border-radius: 2px;
        left: 0;
        right: 0;

      }
    }


    .values {
      display: flex;
      justify-content: center;
      gap: 10px;
    }
  }
</style>
